import moment from "moment";
import { PhoneIcon, VideoCallIcon, WhatsappIcon } from "../icons";
import { defaultPaginationValues } from "./constant";
import parsePhoneNumberFromString from "libphonenumber-js";

export const getIcon = (value)=>{
    switch (value?.toLowerCase()) {
        case "whatsapp":
            return  <WhatsappIcon />
        case "video":
            return  <VideoCallIcon />
        case "audio":
            return  <PhoneIcon />
       case "voice":
            return  <PhoneIcon />
        default:
            return ""
    }
}

export const hasModuleAccess = (roles, modules, isExact = true) => {
  let toAccess = Array.isArray(modules) ? modules : [modules];

  return roles?.some(ele => {
    if (ele?.allowed !== 1 || !ele?.module) return false;

    return toAccess.some(item => {
      const target = item?.toLowerCase();
      const roleModule = ele?.module?.toLowerCase();

      if (isExact) {
        // ✅ exact match only
        return target === roleModule;
      } else {
        // ✅ parent → child only (not the reverse)
        return target === roleModule || roleModule.startsWith(target);
      }
    });
  });
};


export const getFilterQuery = (searchFilter = {}) => {
    if (typeof searchFilter !== "object") return ""
    const objectKeys =  Object.keys(searchFilter)
    
    let searchQuery = objectKeys?.map(key => {
      const valueType = typeof searchFilter[key]
      if (valueType == "string" || valueType == "number" || valueType ==="boolean") {
        if (key === "page" && objectKeys.includes("pageSize")) {
          return `${key}=${searchFilter[key] + 1 || ""}`
        } else if (key === "pageSize") {
          return `limit=${searchFilter[key] || ""}`
        }
        return `${key}=${searchFilter[key] || ""}`
      } else if (Array.isArray( searchFilter[key])) {
           return `${key}=${searchFilter[key] || ""}`
        } else if (valueType == "object") {
            return `${key}=${searchFilter?.[key]?.value || searchFilter?.[key]}`
        }
        return ""
    }).filter(Boolean).join("&")
    return searchQuery ? `?${searchQuery}` : ""
}

export const jsonParserFormatter = (values) => {
  const searchFilter = typeof values === "string" ? JSON.parse(values) : values;
  if (!searchFilter || typeof searchFilter !== "object") return {};
  return searchFilter
}

export const formatMultiQueryParams = (values = {}) => {
  try {
    // Safely parse if string
    const searchFilter = typeof values === "string" ? JSON.parse(values) : values;
    if (!searchFilter || typeof searchFilter !== "object") return {};

    const searchQuery = {...defaultPaginationValues};

    for (const [key, rawValue] of Object.entries(searchFilter)) {
      if (rawValue == null) continue; // skip null/undefined
      if(!rawValue) continue;

      // Handle primitives directly
      if (["string", "number", "boolean"].includes(typeof rawValue)) {
        searchQuery[key] = rawValue;
        continue;
      }

      // Handle arrays (extract `.value` or keep strings)
      if (Array.isArray(rawValue)) {
        const formatted = rawValue
          .map(item => (typeof item === "object" && item?.value) ? item.value :
                       typeof item === "string" ? item : (item.value===false ? false : null))
          .filter(item=>item || item===false);
        if (formatted.length) searchQuery[`${key}[in]`] = formatted;
        continue;
      }

      // Handle nested object
      if (typeof rawValue === "object") {
        const entries = Object.entries(rawValue);
        if (entries.length === 0) continue;

        // Join key-value pairs with "-"
        const formattedKey = entries.map(([k]) => k).join("-");
        const formattedValue = entries.map(([,v]) => v).join(",");
        if(entries.map(([,v]) => v)?.length<=0) continue
        searchQuery[`${key}[${formattedKey}]`] = formattedValue;
        continue;
      }
    }

    return searchQuery;
  } catch (error) {
    console.error("formatMultiQueryParams error:", error);
    return {};
  }
};


export function getStatusLabel(value) {
  switch (value?.toLowerCase()) {
    case 'pending':
      return 'Pending';
    case 'interested':
      return 'Interested';
    case 'call_back_request':
      return 'Call back request';
    case 'not_interested':
      return 'Not Interested';
    case 'not_eligible':
      return 'Not Eligible';
    case 'prospect_for_next_session':
      return 'Prospect for next session';
    case 'registration_done':
      return 'Registration Done';
    case 'partial':
      return 'Partial';
    case 'paid':
      return 'Paid';
    case 'full':
      return 'Full';
    case 'emi':
      return 'EMI';
    case 'bank':
      return 'Bank Transfer';
    case 'failed':
      return 'Failed';
    case 'succeeded':
      return 'Succeeded';
    case 'approved':
      return 'Approved';
    case 'draft':
      return 'Draft';
    case 'rework':
      return 'Rework';
    case 're-submitted':
      return 'Re-submitted';
    default:
      return value; // fallback
  }
}

export const getStatusColors = (status) => {
    const cleanedStatus = status?.trim();
    switch (cleanedStatus) {
      case 'Interested':
        return { brdColor: '#007BE5', textColor: '#fff' };
      case 'Call back request':
        return { brdColor: '#FCBA22', textColor: '#fff' };
      case 'Pending':
        return { brdColor: '#18b4fdff', textColor: '#fff' };
      case 'Not Interested':
        return { brdColor: '#DC3412', textColor: '#fff' };
      case 'Prospect for next session':
        return { brdColor: '#8638E5', textColor: '#fff' };
      case 'Registration Done':
        return { brdColor: '#67CA16', textColor: '#fff' };
      case 'Not Eligible':
        return { brdColor: '#007BE5', textColor: '#fff' };
      default:
        return { brdColor: '#f5f5f5', textColor: '#000' };
    }
};

export function getImageType(value) {
  switch (value?.toLowerCase()) {
    case 'bank':
      return '/assets/images/otherimages/pay5.png';
    default:
      return ''; // fallback
  }
}

export const formattedAmount  = (number,currency)=>{
  return parseFloat(!isNaN(number) ? number : 0).toLocaleString('en-IN', {
  style: 'currency',
  currency: currency || 'INR',
})
}

export function formatDate(date) {
  return moment(date).format('DD MMM YYYY');
}

export const getShortFormat = (fullName) => {
  if (!fullName) return '';
  const words = fullName.trim().split(' ').filter(Boolean);
  if (words.length === 1) return words[0][0]?.toUpperCase() || '';
  if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
  return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
};

export const timeFormat = (seconds = 0) => {
  if (isNaN(seconds)) return `00:00:00`
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

export const getDateFormat=(date,format="DD/MM/YYYY")=>{
  if(!date) return "-"
  return moment(date).format(format || "DD/MM/YYYY")
}


export const getCurrencySymbol = (currencyCode, locale = 'en-US') => {
  try {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'narrowSymbol', // or 'symbol' for a wider symbol
    });
    const parts = formatter.formatToParts(0); // Format a dummy number to get parts
    const currencyPart = parts.find(part => part.type === 'currency');
    return currencyPart ? currencyPart.value : undefined;
  } catch (error) {
    console.error(`Error getting currency symbol for ${currencyCode}:`, error);
    return undefined;
  }
}

export function formatStoredPhone(stored) {
  if (!stored) return "";
   const phone = parsePhoneNumberFromString("+" + stored);

  return `+${phone?.countryCallingCode} ${phone?.nationalNumber}`;
}